export default __webpack_public_path__ + "static/media/order.da7fd695.svg";